import angular from 'angular';

class folderRouteCtrl {
  /* @ngInject */
  constructor($scope, $state, $translate, $sessionStorage, toastr, i18nService, CompanyService) {
    this.$scope = $scope;
    this.$state = $state;
    this.$translate = $translate;
    this.$sessionStorage = $sessionStorage;
    this.toastr = toastr;
    this.i18nService = i18nService;
    this.CompanyService = CompanyService;
  }

  $onInit() {
    this.i18nService.setCurrentLang(this.$translate.use());

    this.$scope.includes = {
      folder: require('./folder/folder.html')
    };

    if (!this.keepFilter) {
      this.$sessionStorage.folderHistorySearchCriteria = null;
    }

    // Fournit aux onglets l'indication d'utiliser des critères de recherche spécifiques
    this.specificFormFolder = this.specificForm;

    this.$scope.getTableHeight = function(gridApi) {
      var rowHeight = 30;
      var headerHeight = 30;
      var scrollHeight = 20;
      var footerHeight = 32;
      return {
        height:
          gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight +
          headerHeight +
          scrollHeight +
          footerHeight +
          'px'
      };
    };
  }
}

angular.module('dashboard').component('folderRoute', {
  templateUrl: require('./folder-route.html'),
  controller: folderRouteCtrl,
  bindings: {
    specificForm: '<',
    keepFilter: '<'
  }
});
